import React from "react";
import { Button } from "../ui/button";
import Image from "../Tags/Image";
import { Plus } from "lucide-react";

/**
 *
 * @param {Object} props
 * @param {Function} props.onButtonClick
 * @param {string} props.buttonText
 * @param {string} props.className
 */
export default function EmptyStateView({ onButtonClick, buttonText = "Add New Number", className = "" }) {
  return (
    <div className={`flex flex-col items-center justify-center min-h-[600px] px-4 ${className}`}>
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <Image
            src="/images/icons/untitledui/number-inventory/inventory-feature-promotion-view.svg"
            alt="Add your first item"
            className="mx-auto max-w-[240px] w-full"
          />
        </div>

        <h2 className="text-base  dark:text-white mb-[29px]">
          Ready, set, dial! Add a number to get things rolling.
        </h2>

        {onButtonClick && (
          <Button onClick={onButtonClick} className="">
            <Plus className="h-4 w-4 mr-2" />
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
}
